/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Practice_Session_Audio_Device_MicrophoneInputs */



/**
* | output |
* | --- |
* | "Microphone {index}" |
*
* @param {Practice_Session_Audio_Device_MicrophoneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_audio_device_microphone = /** @type {((inputs: Practice_Session_Audio_Device_MicrophoneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Audio_Device_MicrophoneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Microfoon ${i?.index}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Micro ${i?.index}`)
	return /** @type {LocalizedString} */ (`Microphone ${i?.index}`)
});